import React, { useState } from "react"
import {
  Box,
  Text,
  Heading,
  Grid,
  Input,
  Textarea,
  Checkbox,
  Label,
  Button,
  Flex,
  Container,
  Image,
} from "@theme-ui/components"
import ArrowRight from "../../images/arrow-right.svg"
import "leaflet/dist/leaflet.css"
import { i18nContext } from "../../context/i18nContext"
import axios from "axios"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

const ContactForm = ({
  block,
  title,
  subtitle,
  privacyPolicyDescription,
  newsletterDescription,
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  console.log(block)

  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    azienda: "",
    telefono: "",
    email: "",
    messaggio: "",
  })

  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const sendMail = async event => {
    event.preventDefault()

    const result = await executeRecaptcha("dynamicAction")

    setLoading(true)

    const data = formData

    if (result)
      axios
        .post("/.netlify/functions/sendMail", data)
        .then(function (response) {
          setSuccess(true)
          setLoading(false)

          if (typeof window !== "undefined" && window.dataLayer !== undefined) {
            window.dataLayer = window.dataLayer || []

            window.dataLayer.push({
              event: "formSubmission",
              formType: "Contact",
            })
          }
        })
        .catch(function (error) {
          setLoading(false)
        })
    else setLoading(false)
  }

  return (
    <i18nContext.Consumer>
      {t => (
        <Container sx={{ mt: 4 }}>
          <Grid columns={[1, 1, 2]}>
            <Box sx={{ mb: [3, 3, 3, 7] }}>
              <Text sx={{ display: "block" }} variant="kicker">
                {block.kicker}
              </Text>
              <Flex
                sx={{
                  flexDirection: ["column", "column", "row", "row"],
                  justifyContent: "space-between",
                  my: [2, 2, 2, 4],
                }}
              >
                <Heading variant="h3" sx={{ flexBasis: "100%" }}>
                  {block.title}
                </Heading>
                <Box
                  sx={{ color: "dark", flexBasis: "80%", fontSize: "21px" }}
                  dangerouslySetInnerHTML={{ __html: block.subtitle }}
                />
              </Flex>
            </Box>
            <form onSubmit={sendMail}>
              <Box
                sx={{
                  input: {
                    position: "relative",
                    borderColor: "dark",
                    borderRadius: 0,
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    borderBottom: "2px solid dark",
                    pt: 4,
                    fontSize: "25px",
                    "&::placeholder": {
                      fontSize: "15px!important",
                      fontWeight: 500,
                      color: "dark",
                      position: "absolute",
                      top: "0px",
                    },
                  },
                }}
              >
                <Grid
                  sx={{
                    flexWrap: "wrap",
                    flexDirection: "column",
                    pb: [6, 6, 0, 0],
                  }}
                  gap={[0, 0, 0, 0]}
                >
                  <Flex
                    sx={{
                      gap: 3,
                      pb: [4, 4, 4, 4],
                      width: ["100%", "100%"],
                    }}
                  >
                    <Input
                      onChange={e =>
                        setFormData(prevState => ({
                          ...prevState,
                          nome: e.target.value,
                        }))
                      }
                      name={t.formInputTexts.name}
                      placeholder={t.formInputTexts.name}
                      variant="inputs.primary"
                      required
                    />
                    <Input
                      onChange={e =>
                        setFormData(prevState => ({
                          ...prevState,
                          cognome: e.target.value,
                        }))
                      }
                      name={t.formInputTexts.surname}
                      placeholder={t.formInputTexts.surname}
                      variant="inputs.primary"
                      required
                    />
                  </Flex>
                  <Grid columns={[1, 2]}>
                    <Box
                      sx={{
                        pb: [4, 4, 4, 4],
                        width: ["100%", "100%"],
                      }}
                    >
                      <Input
                        onChange={e =>
                          setFormData(prevState => ({
                            ...prevState,
                            telefono: e.target.value,
                          }))
                        }
                        name={t.formInputTexts.phone}
                        placeholder={t.formInputTexts.phone}
                        inputmode="tel"
                        variant="inputs.primary"
                        required
                      />
                    </Box>
                    <Box
                      sx={{
                        pb: [4, 4, 4, 4],
                        width: ["100%", "100%"],
                      }}
                    >
                      <Input
                        onChange={e =>
                          setFormData(prevState => ({
                            ...prevState,
                            email: e.target.value,
                          }))
                        }
                        name="email"
                        type="email"
                        placeholder="Email"
                        variant="inputs.primary"
                        required
                      />
                    </Box>
                  </Grid>
                  <Box
                    sx={{
                      pb: [4, 4, 4, 4],
                      width: ["100%", "100%"],
                    }}
                  >
                    <Input
                      onChange={e =>
                        setFormData(prevState => ({
                          ...prevState,
                          azienda: e.target.value,
                        }))
                      }
                      name={t.formInputTexts.company}
                      placeholder={t.formInputTexts.company}
                      variant="inputs.primary"
                      required
                    />
                  </Box>

                  <Textarea
                    sx={{
                      borderBottom: "1px solid",
                      borderTop: "none",
                      borderLeft: "none",
                      borderRight: "none",
                      borderColor: "dark",
                      borderRadius: 0,
                      "&::placeholder": {
                        color: "dark",
                      },
                      pb: 8,
                      fontFamily: "body",
                      fontSize: [2],
                    }}
                    onChange={e =>
                      setFormData(prevState => ({
                        ...prevState,
                        messaggio: e.target.value,
                      }))
                    }
                    name={t.formInputTexts.message}
                    placeholder={t.formInputTexts.message}
                    type="textarea"
                  />
                  <Box sx={{ py: 2 }}>
                    <LabeledCheckbox required={true}>
                      <Box
                        sx={{
                          p: {
                            mt: 2,
                            mb: 0,
                            fontSize: [0],
                            color: "dark",
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: privacyPolicyDescription,
                        }}
                      />
                    </LabeledCheckbox>
                  </Box>

                  {!success ? (
                    <Flex sx={{ justifyContent: "flex-end" }}>
                      <Button
                        variant="kicker"
                        type="submit"
                        sx={{
                          display: "flex",
                          cursor: "pointer",
                          ":hover": {
                            backgroundColor: "secondary",
                          },
                          alignContent: "center",
                          alignItems: "center",
                          gap: 2,
                          mt: [3, 3, 3, 3],
                          borderRadius: "80px",
                          textTransform: "uppercase",
                        }}
                      >
                        <i18nContext.Consumer>
                          {t => <>{loading ? t.loading : t.sendRequestForm}</>}
                        </i18nContext.Consumer>
                        <Box>
                          <Image src={ArrowRight} />
                        </Box>
                      </Button>
                    </Flex>
                  ) : (
                    <Button
                      type="submit"
                      sx={{
                        mt: [3, 3, 3, 3],
                        color: "primary",
                        backgroundColor: "lightgray",
                      }}
                      variant="kicker"
                      disabled
                    >
                      {t.requestSent}
                    </Button>
                  )}
                </Grid>
              </Box>
            </form>
          </Grid>
        </Container>
      )}
    </i18nContext.Consumer>
  )
}

const LabeledCheckbox = ({ children, defaultChecked, ...props }) => {
  const [checked, setChecked] = useState(defaultChecked)
  return (
    <Label
      sx={{
        display: "flex",
        alignItems: "center",
        color: "text",
        svg: {
          color: "primary",
        },
        mt: [3, 3, 3, 3],
      }}
    >
      <Checkbox
        checked={checked}
        onChange={() => setChecked(!checked)}
        {...props}
      />
      {children}
    </Label>
  )
}

export default ContactForm
